<template>
  <div class="checkbox_wrapper mr-1" @click="changeState">
    <span v-if="labelPosition == 'left'" :style="{color: labelColor}" :class="['check_text', labelClass]">{{label}}</span>
    <b-img
      class="img_container"
      :src="src"
      ></b-img>
    <span v-if="labelPosition == 'right'" :style="{color: labelColor}" :class="['check_text', labelClass]">{{label}}</span>
  </div>
</template>

<script>
    export default {
      name: "MdSearchSingleCheckBox",
      props: {
        label:{type:String},
        variant:{type:String, default:'primary'},
        labelPosition:{type:String, default: 'left'},
        labelColor:{type:String},
        labelClass:{type:String},
        readonly: {type:Boolean, default: false},
        state: {type:Boolean, default: false},
      },
      data() {
        return {
          check_state: false,
          value: '',
        }
      },
      computed:{
        src(){
          return this.check_state?  ((this.variant === 'primary')? require('../../../assets/image/ic_check_on@2x.png') :
              require('../../../assets/image/ic_check_any_on@2x.png')):
            require('../../../assets/image/ic_check_off@2x.png')
        }
      },
      methods: {
        changeState() {
          if (this.$listeners.click != null){
            // this.check_state = true;
            this.$emit('click');
          }else{
            if (!this.readonly){
              this.check_state = !this.check_state;
              this.$emit('input', this.check_state ? 'Y' : 'N')
            }
          }
        },
      },
      mounted() {
        this.check_state = this.state;
      },
      watch:{
        state(){
          this.check_state = this.state;
        }
      }
    }
</script>

<style scoped lang="scss">
  @import "../../../assets/css/main/more/RegNewOpenSite1";
  .img_container {
    width: 16px;
    height: auto;
  }
  .checkbox_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }
  .answer_text {
    color: #4e4e4e;
    font-size: $fs_18;
    margin-left: 10px;
    font-family: $korean_gd_12_r;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MdSearchSingleCheckBox.vue